import { mergeDeepSafe, resolveAliases } from '../../../utils';
import { CoreTheme, GeneratedTheme } from '../../types';
import mapCoreTheme from '../mappers/mapCoreTheme';
import { ThemeOverrides } from '../types';

type Props = {
  generatedTheme: GeneratedTheme;
  overrides: Pick<ThemeOverrides, 'core'>;
};

const resolveCoreTheme = ({ generatedTheme, overrides }: Props): CoreTheme => {
  const partiallyResolvedTheme = resolveAliases({
    core: generatedTheme.core,
  }) as Pick<GeneratedTheme, 'core'>;

  const mappedCore = mapCoreTheme(partiallyResolvedTheme.core);

  const core = overrides.core
    ? mergeDeepSafe(mappedCore, overrides.core({ core: mappedCore }))
    : mappedCore;

  return core;
};

export default resolveCoreTheme;
